import { LogoContainer } from 'reservations/payments/components/LogoContainer';

export function VisaLogo() {
  return (
    <LogoContainer>
      <svg
        data-testid="visa-logo"
        width="32"
        height="20"
        viewBox="0 0 32 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.2722 18.2848H31.2468V18.7848C31.2468 19.0909 30.9897 19.3481 30.6836 19.3481H1.06329C0.757156 19.3481 0.5 19.0909 0.5 18.7848V1.06329C0.5 0.757155 0.757155 0.5 1.06329 0.5H30.7089C31.015 0.5 31.2722 0.757154 31.2722 1.06329V18.2848Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M14.6078 12.9115H13.0635L14.0255 6.93677H15.5951L14.6078 12.9115Z"
          fill="#0066B2"
        />
        <path
          d="M11.7469 6.9375L10.2785 11.0388L10.1013 10.1527L9.56968 7.46915C9.56968 7.46915 9.51905 6.9375 8.83551 6.9375H6.37981L6.35449 7.03877C6.35449 7.03877 7.11399 7.19066 7.97475 7.72231L9.34184 12.9122H10.9621L13.4178 6.9375H11.7469Z"
          fill="#0066B2"
        />
        <path
          d="M23.949 12.9113H25.3667L24.1262 6.96191H22.8857C22.3034 6.96191 22.1768 7.41761 22.1768 7.41761L19.873 12.9113H21.4933L21.8224 12.0252H23.7971L23.949 12.9113ZM22.2528 10.7847L23.0629 8.55685L23.5186 10.7847H22.2528Z"
          fill="#0066B2"
        />
        <path
          d="M19.9744 8.37975L20.2022 7.08861C20.2022 7.08861 19.5187 6.83545 18.8098 6.83545C18.0503 6.83545 16.2022 7.16456 16.2022 8.81013C16.2022 10.3544 18.3541 10.3798 18.3541 11.1646C18.3541 11.9747 16.4301 11.8228 15.7972 11.3165L15.5693 12.6582C15.5693 12.6582 16.2529 12.9873 17.3162 12.9873C18.3795 12.9873 19.9744 12.4304 19.9744 10.9367C19.9744 9.39241 17.7972 9.24051 17.7972 8.58229C17.8225 7.92406 19.3162 8.02532 19.9744 8.37975Z"
          fill="#0066B2"
        />
        <path
          d="M10.1013 10.1527L9.56968 7.46915C9.56968 7.46915 9.51905 6.9375 8.8355 6.9375H6.37981L6.35449 7.03877C6.35449 7.03877 7.51905 7.29193 8.65829 8.20332C9.7469 9.06408 10.1013 10.1527 10.1013 10.1527Z"
          fill="#F9A533"
        />
      </svg>
    </LogoContainer>
  );
}
